import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { DataMap } from '@grapecity/wijmo.grid'
import { SchedulingTransport } from 'src/app/shared'
import { fromMapToList } from 'src/app/shared/shared-functions'

import { ListItem, RepositoryModal } from '../../../shared'

@Component({
    templateUrl: './transport.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class SchedulingTransportComponent extends RepositoryModal<SchedulingTransport> implements OnInit {
    priorityList: ListItem<number>[] = []
    jobList: ListItem<string>[] = []
    userList: ListItem<number>[] = []

    ngOnInit(): void {
        this.priorityList = this.editOptions.initializeParams.priorityList
        this.jobList = this.editOptions.initializeParams.jobList

        if (this.isAdding) {
            this.target.priority = this.priorityList[0].value
        }

        const dm = this.editOptions.initializeParams.activeUserMap as DataMap
        this.userList = fromMapToList(dm, 'id', 'name')
    }

    protected onBeforeSave(): boolean {
        return true
    }
}
